/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Rentenversicherungsnr2Inputs */



/**

* @param {Validation_Rentenversicherungsnr2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const validation_rentenversicherungsnr2 = /** @type {((inputs?: Validation_Rentenversicherungsnr2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Rentenversicherungsnr2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Ungültige Rentenversicherungsnummer.")
});
export { validation_rentenversicherungsnr2 as "validation_rentenVersicherungsNr" }